import styles from "./ContractStyles";

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        margin: 10,
        marginLeft: 20,
        padding: 10,
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 14,
            marginTop: 15,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
          },
          content: "AGENCY AGREEMENT FOR YACHTING SERVICES",
        },

        {
          type: "text",
          styles: {
            fontFamily: "Helvetica-Oblique",
            textAlign: "center",
            paddingLeft: 40,
            paddingRight: 40,
            fontSize: 11,
          },
          content:
            "This document, prepared and provided by ECPY to its members, creates a transparent intermediary agreement in view of the signature of Transport and Services Agreements for Yachts.",
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
                textTransform: "uppercase",
              },
              content: "The principal",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",
          styles: {
            border: "1pt solid #000000",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderRight: "1pt solid #000000",
                    borderBottom: "1pt solid #000000",
                    padding: "5pt",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "1. PRINCIPAL",
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 9,
                            fontFamily: "Helvetica-Oblique",

                            //fontStyle: "italic",
                          },
                          content:
                            ' represented by "name, signatory\'s status, full address", duly authorized to represent the Principal for the signature of this document',
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                      },
                      content: "__agreement_principal__",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderBottom: "1pt solid #000000",
                    padding: "5pt",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "2. Status of the Principal",
                    },

                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                      },
                      items: [
                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_principal_status_owner",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_principal_status_owner__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField:
                                "agreement_principal_status_charterer",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content:
                                "__agreement_principal_status_charterer__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_principal_status_other",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_principal_status_other__",
                            },
                          ],
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "column" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto-Bold",
                            fontSize: 9,
                          },
                          content: "3. Type of agreement",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_type__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "AGREEMENT CURRENCY : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_currency__",
                        },
                      ],
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderRight: "1pt solid #000000",
                    padding: "5pt",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "4. Name and characteristics of yacht",
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "NAME : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_yacht_name__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "IMO N° : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_imo_number__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "FLAG : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_flag_state__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "LENGTH OA : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_lenght_OA__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "TYPE : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_yacht_type__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    padding: "5pt",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "5. Agreement term",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                      },
                      content:
                        "From __agreement_term_from__ to __agreement_term_to__",
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "EXCLUSIVE AGREEMENT : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_term_exclusive__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "6. Cruising area",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                      },
                      content: "__agreement_cruising_area__",
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
                textTransform: "uppercase",
              },
              content: "The agent",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            border: "1pt solid #000000",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "50%",
                borderRight: "1pt solid #000000",
                padding: "5pt",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "7. AGENT",
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 9,
                        fontFamily: "Helvetica-Oblique",
                      },
                      content:
                        'represented by "name, signatory\'s status, full address", duly authorized to represent the client for the signature of this document',
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 11,
                  },
                  content: "__agreement_agent__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "50%",
                padding: "5pt",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "8. Role of the agent (cf. details below)",
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "agreement_agent_role_broker",
                          styles: {
                            ...styles.checkbox,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_role_broker__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "agreement_agent_role_ca",
                          styles: {
                            ...styles.checkbox,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_role_ca__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "agreement_agent_role_stakeholder",
                          styles: {
                            ...styles.checkbox,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_role_stakeholder__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "agreement_agent_role_other",
                          styles: {
                            ...styles.checkbox,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_role_other__",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "ADDITIONAL DETAILS REGARDING THE AGREEMENT",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",
          styles: {
            border: "1pt solid #000000",
          },

          items: [
            {
              type: "view",
              styles: {
                borderBottom: "1pt solid #000000",
                padding: "5pt",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "9. Delegated operations",
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        width: "50%",
                      },
                      items: [
                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_1",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_1__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_2",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_2__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_3",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_3__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_4",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_4__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_5",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_5__",
                            },
                          ],
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        width: "50%",
                      },
                      items: [
                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_6",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_6__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_7",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_7__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_8",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_8__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            ...styles.checkboxWrapper,
                          },
                          items: [
                            {
                              type: "view",
                              specialType: "checkbox",
                              linkedField: "agreement_delegated_operations_9",
                              styles: {
                                ...styles.checkbox,
                              },
                              items: [],
                            },

                            {
                              type: "text",
                              specialType: "display-everytime",
                              styles: {
                                ...styles.textContent,
                                fontSize: 11,
                              },
                              content: "__agreement_delegated_operations_9__",
                            },
                          ],
                        },

                        {
                          type: "view",
                          repeated: true,
                          findRepeated: "agreement_other_delegated",
                          items: [
                            {
                              type: "view",
                              styles: {
                                ...styles.checkboxWrapper,
                              },
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  linkedField: "agreement_other_delegated",
                                  styles: {
                                    ...styles.checkbox,
                                    ...styles.checkboxChecked,
                                  },
                                  items: [],
                                },

                                {
                                  type: "text",
                                  specialType: "display-everytime",
                                  styles: {
                                    ...styles.textContent,
                                    fontSize: 11,
                                  },
                                  content: "__agreement_other_delegated__",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderRight: "1pt solid #000000",
                    padding: "5pt",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "10. Agent's bank details (if Stakeholder)",
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "BANK : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content:
                            "__agreement_agent_bank_details_bankDesignation__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "ACCOUNT NAME : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content:
                            "__agreement_agent_bank_details_bankAccountName__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "ADDRESS : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content:
                            "__agreement_agent_bank_details_bankAddress1__ __agreement_agent_bank_details_bankAddress2__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "IBAN : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_bank_details_bankIban__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "SWIFT : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content:
                            "__agreement_agent_bank_details_bankBicSwift__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    height: "100%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "11. Agent's insurance and financial guarantee",
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 9,
                          },
                          content: "(when applicable)",
                        },
                      ],
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "INSURANCE : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_insurance__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "FINANCIAL GUARANTEE : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_financial__",
                        },
                      ],
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderRight: "1pt solid #000000",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "12. Agent's remuneration",
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "COMMISSION : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_commission__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                          },
                          content: "(specify currency) ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 11,
                          },
                          content: "__agreement_agent_currency__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",

                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "13. Agent's payment terms and conditions",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                      },
                      content: "__agreement_agent_terms__",
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            border: "1pt solid #000000",
            flexDirection: "row",
            marginTop: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                borderRight: "1pt solid #000000",
                width: "50%",
                padding: "5pt",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    ...styles.checkboxWrapper,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkbox,
                      },
                      items: [],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 9,
                      },
                      content:
                        "I have read, understood and accept all of the terms of the agreement and the general conditions overleaf.",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 9,
                  },
                  content: "Date, signature and stamp of the Principal",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 9,
                  },
                  content: '"Valid for agreement"',
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "FOR THE PRINCIPAL",
                },

                {
                  type: "view",
                  styles: {
                    height: "50pt",
                  },
                  items: [],
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "50%",
                padding: "5pt",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    ...styles.checkboxWrapper,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkbox,
                      },
                      items: [],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 9,
                      },
                      content:
                        "I have read, understood and accept all of the terms of the agreement and the general conditions overleaf.",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 9,
                  },
                  content: "Date, signature and stamp of the Agent",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 9,
                  },
                  content: '"Valid for agreement"',
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "FOR THE AGENT",
                },

                {
                  type: "view",
                  styles: {
                    height: "50pt",
                  },
                  items: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
